import type { ReactNode, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface SameTabLinkProps {
  to: string;
  children: ReactNode;
  className?: string;
}

export default function SameTabLink({ to, children, className }: SameTabLinkProps) {
  const navigate = useNavigate();

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    navigate(to);
  };

  return (
    <a href={to} onClick={handleClick} className={className}>
      {children}
    </a>
  );
}
